import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import CloudinaryImage from '../common/CloudinaryImage';
import Container from '../common/Container';

export default function DifferenceService({ data }) {
  const [visibleCount, setVisibleCount] = useState(6); // Default to 6 items

  const handleShowMore = () => {
    setVisibleCount(prev => prev + 6); // Show 6 more items
  };

  const handleShowLess = () => {
    setVisibleCount(6); // Reset to default
  };
  return (
    <Container>
      <div
        className={
          data?.title && 'lg:mb-[35px] mb-[30px] text-white max-w-[1200px]'
        }
      >
        {data?.title && (
          <h2
            className={`font-[700] xl:text-[55px] md:text-[32px] text-[25px] leading-tight mb-3`}
          >
            {data?.title}
          </h2>
        )}
        {data?.description && (
          <p className="lg:text-[20px] text-[16px] font-[400]">
            {data?.description}
          </p>
        )}
      </div>
      <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1">
        {data?.CostBlog?.slice(0, visibleCount).map((items, index) => (
          <div
            key={items?.id}
            className={`px-5 py-5 duration-300 ease-in-out ${
              (index === 0 ||
                index === 1 ||
                index === 2 ||
                index === 6 ||
                index === 7 ||
                index === 8) &&
              'border-b-[1px] border-[#B8B8B84A]'
            } ${
              (index === 0 ||
                index === 1 ||
                index === 3 ||
                index === 4 ||
                index === 6 ||
                index === 7 ||
                index === 9 ||
                index === 10) &&
              'lg:border-r-[1px] lg:border-[#B8B8B84A]'
            } ${
              (index === 3 || index === 4 || index === 5) &&
              visibleCount > 6 &&
              'border-b-[1px] border-[#B8B8B84A]'
            } ${
              (index === 9 || index === 10 || index === 11) &&
              visibleCount > 12 &&
              'border-b-[1px] border-[#B8B8B84A]'
            } hover:bg-[linear-gradient(181.36deg,_#000815_14.18%,_#050470_111.88%)]`}
          >
            {items?.icon?.data?.attributes?.url && (
              <CloudinaryImage
                backendImgUrl={items?.icon?.data?.attributes?.url}
                width={'70px'}
                height={'70px'}
                className={'w-[70px] h-[70px]'}
                alt={items?.icon?.data?.attributes?.alternativeText}
                type="icon"
              />
            )}
            <h6
              className={`lg:text-[28px] md:text-[22px] text-[20px] text-[#FFFFFF] font-[700] ${items?.title && 'mt-3'}`}
            >
              {items?.title}
            </h6>
            <p
              className={`lg:text-[16px] text-[14px] text-[#ffffffe0] font-[400] leading-tight ${items?.description && 'mt-3'}`}
            >
              {items?.description}
            </p>
            {items?.editor && (
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                className={`lg:text-[16px] text-[14px] text-[#ffffffe0] font-[400] leading-tight ${items?.editor && 'mt-3'}`}
                source={items?.editor}
              >
                {items?.editor}
              </ReactMarkdown>
            )}
          </div>
        ))}
      </div>

      <div className="text-center">
        {visibleCount < data?.CostBlog?.length && (
          <button
            onClick={handleShowMore}
            className="lg:mt-[45px] mt-[30px] mr-3 btncolorleftright inline-block border-[1px] border-[#fff] text-[#fff] py-2 lg:px-10 px-5 lg:text-[20px] text-[14px] font-[500] relative overflow-hidden"
          >
            <span className="relative z-[5] transition duration-300 ease-in-out">
              {data?.btn_txt}
            </span>
          </button>
        )}
        {visibleCount > 6 && (
          <button
            onClick={handleShowLess}
            className="lg:mt-[45px] mt-[30px] ml-3 btncolorleftright inline-block border-[1px] border-[#fff] text-[#fff] py-2 lg:px-10 px-5 lg:text-[20px] text-[14px] font-[500] relative overflow-hidden"
          >
            <span className="relative z-[5] transition duration-300 ease-in-out">
              Show Less
            </span>
          </button>
        )}
      </div>
    </Container>
  );
}
